import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import localization from '../../../shared/Localization';
import { Bird } from '../../../constants/Icons'
import { RouteNames } from '../../../shared/enums/RouteNames';
import sharedHistory from '../../../shared/History';
import I18n from 'i18n-js';
import { Auth } from 'aws-amplify';
import './Login.scss';
import { connect } from 'react-redux';
import { SetUserObject } from '../../../store/actions/user/UserActions';
import { ThunkDispatch } from 'redux-thunk';
import { PasswordInput } from "../../shared/PasswordInput/PasswordInput";
import AppleAppStore from "../../../images/badge-apple-app-store.png";
import GooglePlayStore from "../../../images/badge-google-play.png";
import { getQueryParam } from '../../../shared/Navigation';
import Settings from '../../../constants/Settings';

export const FormIds = {
    username: 'Username',
    password: 'Password',
    rememberme: 'Rememberme',
    signInBtn: 'SignIn'
}

interface ILoginProps {
    setUserObject: (userObj: ICognitoUser) => {}
}

export function Login(props: ILoginProps) {
    const [local, setLocal] = useState<typeof I18n | undefined>(undefined);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [rememberme, setRememberme] = useState(true);
    const [signInErrorMessage, setSignInErrorMessage] = useState("");

    const [usernameValidation, setUsernameValidation] = useState({} as IFieldValidation);
    const [passwordValidation, setPasswordValidation] = useState({} as IFieldValidation);

    useEffect(() => {
        const getLocal = async () => {
            setLocal(await localization("en"));
        }

        getLocal();
    });

    async function signIn(event: any) {
        event.preventDefault();
        setUsernameValidation(validateFieldRequred(FormIds.username, username));
        setPasswordValidation(validateFieldRequred(FormIds.password, password));

        if (usernameValidation.message?.length === 0 && passwordValidation.message?.length === 0) {
            try {
                await Auth.signIn(username, password);
                const user = await Auth.currentAuthenticatedUser();
                props.setUserObject(user);
                const returnUrl = getQueryParam('returnUrl');
                if (returnUrl) {
                    window.location.assign(returnUrl);
                    return;
                }
                sharedHistory.push(RouteNames.Home);
            }
            catch (signInError: any) {
                setSignInErrorMessage(signInError.message);
            }
        }
    }

    async function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
        if (e.currentTarget.id === FormIds.username) {
            setUsername(e.currentTarget.value);
            setUsernameValidation(validateFieldRequred(FormIds.username, e.currentTarget.value));
        } else if (e.currentTarget.id === FormIds.password) {
            setPassword(e.currentTarget.value);
            setPasswordValidation(validateFieldRequred(FormIds.password, e.currentTarget.value));
        }

        if (signInErrorMessage.length > 0)
            setSignInErrorMessage("");
    }

    const validateFieldRequred = (field: string, value: string): IFieldValidation => {
        return value?.length > 0 ? { class: '', message: '' } : { class: 'invalid', message: `${field} required` }
    }

    return (
        <div className="login">
            <div className="container row">
                <div className="col m7 hide-on-small-only">
                    <div className="icon">
                        {Bird}
                    </div>
                    <div className="center-align">
                        <p className="title" id='i-track-title'>iTrack</p>
                        <p className='title' id='habitat-title'>Habitat</p>
                    </div>
                    <div className="col s12 center-align trademark">
                        Take a walk on the wildside
                    </div>
                </div>
                <form className="col s12 m5" onSubmit={signIn}>
                    <div className="row">
                        <div className="input-field col s12 login-input">
                            <input data-testid={FormIds.username} id={FormIds.username} type="text" className={usernameValidation.class} onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(e)}></input>
                            <label htmlFor={FormIds.username}>Email</label>
                            <span className="helper-text login-field-error" data-error={usernameValidation.message}></span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field col s12 login-input">
                            <PasswordInput
                                onChange={handleChange}
                                id={FormIds.password}
                                ariaLabel={FormIds.password}
                                testId={FormIds.password}
                                inputClassName={passwordValidation.class}
                                helperText={passwordValidation.message}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col s12">
                            <button data-testid={FormIds.signInBtn} className="btn btn-primary button" type="submit">{local && local.t("loginPage.signInButton")}</button>
                            {signInErrorMessage.length > 0 ? <div className="login-error" >{signInErrorMessage}</div> : null}
                        </div>
                    </div>
                    <div className="row remeberme-box">
                        <div className="col s9 link-text remeberme">
                            Remember Me
                        </div>
                        <div className="switch col s3" >
                            <label>
                                <input data-testid={FormIds.rememberme} checked={rememberme} type="checkbox" onChange={() => setRememberme(!rememberme)}></input>
                                <span className="lever"></span>
                            </label>
                        </div>
                    </div>
                    <div className="row col s12 center-align link-box">
                        <Link to={RouteNames.ForgotPassword} className="link">FORGOT PASSWORD?</Link>
                    </div>
                    <div className="row col s12 center-align link-box">
                        <Link to={RouteNames.CreateAccount} className="link">NEED TO MAKE AN ACCOUNT?</Link>
                    </div>
                    <div className="row app-store-container">
                        <a className="col s6" href={Settings.appleStoreUrl} target="_blank" >
                            <img alt="Apple App Store Badge" src={AppleAppStore} />
                        </a>
                        <a className="col s6" href={Settings.androidStoreUrl} target="_blank">
                            <img alt="Google Play Store Badge" src={GooglePlayStore} />
                        </a>
                    </div>
                </form>
            </div>
        </div>
    )
}

const dispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => ({
    setUserObject: (userObject: {}) => dispatch(SetUserObject(userObject))
});

export default connect(undefined, dispatchToProps)(Login);